import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";

export class InstanceManager{
    wrapper: JQuery;
    instanceId:number;
    organisationName:string;

    constructor() {
        this.instanceId = Number($("#instance-id").val())
        this.wrapper = $("#instance-data");
        this.addListeners()
    }

    getData(){
        this.organisationName = $("#name").val().toString();
        this.organisationHandle = $("#un_name").val();
        this.street = $("#strasse").val();
        this.houseNr = $("#hausnr").val();
        this.city = $("#stadt").val()
        this.plz = $("#plz").val();
        this.telefon = $("#telefon").val();
    }

    submitData(btn){
        this.getData();

        const data = {
            organisationName: this.organisationName,
            organisationHandle: this.organisationHandle,
            street: this.street,
            houseNr: this.houseNr,
            city: this.city,
            plz: this.plz,
            telefon: this.telefon,
        }

        const success = function (data){
            successToast("Daten gespeichert", "Erfolg", 5000, true);
        }

        const url = '/instance/' + this.instanceId.toString() + '/update'

        return ajaxRequest(url, success, data, btn)
    }

    addListeners(){
        const self = this;
        this.wrapper.on("click", "#save-instance-data", function(){
            self.submitData($(this));
        })
    }
}

